import { useQueryString } from '#hooks/useQueryString';
import { useGetRecordsV2 } from '#pages/DashboardChartForm/api';
import styled from 'styled-components';
import { match } from 'ts-pattern';
import { NoFeedback } from './NoFeedback';

export const Comment = () => {
  const [registedLectureId] = useQueryString(['registered-lecture-id']);

  const { data } = useGetRecordsV2(registedLectureId);

  if (!data) return <div></div>;

  const userComment = data.registeredLectureRecord.userComment;

  return (
    <div className="w-full">
      <div className="text-[#938f9e] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
        코멘트
      </div>
      <div className="w-full h-8"></div>
      {match(userComment)
        .with(null, () => <NoFeedback />)
        .otherwise(userComment => (
          <Box>{userComment}</Box>
        ))}
    </div>
  );
};

const Box = styled.div`
  display: flex;
  width: 100%;
  min-height: 240px;
  padding: 16px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 12px;
  background: var(--BG-bg-700, #262231);

  color: var(--Gray-Scale-400, #bcb8c3);

  /* NEW/body_02_regular */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;
